import axios from 'axios';

import queryString from '@/utils/queryString';
import { headers, ledgerServiceUrl } from '../../config';

export function getAccountById(id) {
    return axios.get(`${ledgerServiceUrl}/accounts/${id}`, { headers: headers() });
}

export function getAccount({id}) {
    return axios.get(`${ledgerServiceUrl}/accounts/${id}`, { headers: headers() });
}

export function getAccountStatement(payload) {
    let query = queryString(payload);
    return axios.get(`${ledgerServiceUrl}/statements?${query}`, { headers: headers() });
}

export function getGroupAccountByType(payload) {
    let query = queryString(payload);
    return axios.get(`${ledgerServiceUrl}/account-groups?${query}`, { headers: headers() });
}

export function searchAccountByNameOrCode(payload) {
    let query = queryString(payload);
    return axios.get(`${ledgerServiceUrl}/account-search?${query}`, { headers: headers() });
}

/**
 * @param {Array<Number>} ids Get list of accounts where ID in array.
 */
export function getActiveAccountsIn(ids) {
    let payload = {in: ids}
    // let query = queryString(payload);
    return axios.get(`${ledgerServiceUrl}/account-actives`, { params: payload, headers: headers() });
}

export function getAccountsList(params) {
    params.limit = params.itemsPerPage;
    params.offset = (params.page - 1) * params.itemsPerPage;
    return axios.get(`${ledgerServiceUrl}/accounts-list`, { headers: headers(), params });
}

export function freezeAccount(accountIds) {
    return axios.put(`${ledgerServiceUrl}/accounts/freeze`, accountIds, { headers: headers()});
}

export function unfreezeAccount(accountIds) {
    return axios.put(`${ledgerServiceUrl}/accounts/unfreeze`, accountIds, { headers: headers()});
}